// assets/collection-live-search.js
(function() {
  const input = document.querySelector('#collectionLiveSearch');
  if (!input) return;

  const status = document.querySelector('.live-search__status');
  const sectionId = input.dataset.gridSectionId;
  const collectionHandle = input.dataset.collectionHandle;

  let t;
  const debounce = (fn, wait=250) => (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), wait);
  };

  const setLoading = (loading) => {
    if (loading) {
      input.setAttribute('aria-busy', 'true');
      status.textContent = 'Searching…';
    } else {
      input.removeAttribute('aria-busy');
      status.textContent = '';
    }
  };

  const buildSearchUrl = (q) => {
    const url = new URL(window.location.origin + '/search');
    url.searchParams.set('q', q || '');
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.append('constraint', `collection:${collectionHandle}`);
    url.searchParams.set('section_id', sectionId);
    return url.toString();
  };

  const swapGrid = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const incoming = doc.getElementById(sectionId);
    const current = document.getElementById(sectionId);
    if (incoming && current) current.replaceWith(incoming);
  };

  const handleSearch = async () => {
    const q = input.value.trim();
    const url = q ? buildSearchUrl(q) : `${window.location.pathname}?section_id=${sectionId}`;
    try {
      setLoading(true);
      const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const html = await res.text();
      swapGrid(html);
    } catch (e) {
      console.error('Live search failed', e);
      status.textContent = 'Something went wrong. Try again.';
    } finally {
      setLoading(false);
    }
  };

  input.addEventListener('input', debounce(handleSearch, 250));
})();
